/* search.js — site overlay search
   Now backed by Shopify's Predictive Search API for products/articles/pages,
   merged with a small curated list of marketing pages that aren't real
   Shopify page/article objects (service pages, case studies, etc).
*/
// (function(){
//   var overlay = document.getElementById('searchOverlay');
//   var input = document.getElementById('siteSearchInput');
//   var resultsEl = document.getElementById('searchResults');
//   if(!overlay || !input || !resultsEl) return;

//   // Curated marketing pages — keep in sync with the site map.
//   // These are NOT Shopify Page/Article objects, so predictive search can't
//   // find them; they're merged in locally alongside live catalog results.
//   var curatedPages = [
//     {t:'Shopify Development',d:'Custom themes, integrations & migrations',u:'/pages/shopify-development',c:'Shopify'},
//     {t:'Shopify Plus Development',d:'Enterprise builds & replatforming',u:'/pages/shopify-plus-development',c:'Shopify'},
//     {t:'Store Setup & Launch',d:'End-to-end Shopify store builds',u:'/pages/shopify-setup-launch',c:'Shopify'},
//     {t:'Shopify App Development',d:'Custom apps & App Store launches',u:'/pages/shopify-app-development',c:'Shopify'},
//     {t:'Shopify CRO & Audit',d:'Conversion rate optimization',u:'/pages/shopify-cro-audit',c:'Growth'},
//     {t:'Shopify Speed Optimization',d:'Core Web Vitals tuning',u:'/pages/shopify-speed-optimization-1',c:'Growth'},
//     {t:'Shopify Agentic Commerce',d:'ChatGPT, Copilot, Gemini',u:'/pages/shopify-agentic-commerce-1',c:'Growth'},
//     {t:'Shopify Mobile App',d:'iOS & Android native apps',u:'/pages/mobile-app-development',c:'Growth'},
//     {t:'Shopify Support & Maintenance',d:'Retainers & SLAs',u:'/pages/support-and-maintenance',c:'Shopify'},
//     {t:'Web Development',d:'React, Next.js, Node.js',u:'/pages/web-development',c:'Software'},
//     {t:'Mobile App Development',d:'iOS, Android, React Native, Flutter',u:'/pages/mobile-app-development',c:'Software'},
//     {t:'AI & Automation',d:'Agents, MCP, RAG, automation',u:'/pages/ai-automation-solutions',c:'AI'},
//     {t:'Custom Software Development',d:'SaaS, ERP, CRM, internal tools',u:'/pages/custom-software-development',c:'Software'},
//     {t:'Digital Marketing',d:'SEO, paid, email & SMS',u:'/pages/digital-marketing-1',c:'Marketing'},
//     {t:'UI/UX Design',d:'Product design & design systems',u:'/pages/ui-ux-design-1',c:'Design'},
//     {t:'All Services',d:'Browse the full menu',u:'/pages/services',c:'Pages'},
//     {t:'Portfolio',d:'250+ projects delivered',u:'/pages/portfolio',c:'Pages'},
//     {t:'Case Studies',d:'Real client results, real numbers',u:'/pages/case-studies',c:'Pages'},
//     {t:'About Tetralogicx',d:'Our team, story & philosophy',u:'/pages/about-us',c:'Pages'},
//     {t:'Contact',d:'Get a quote or book a call',u:'/pages/contact-us',c:'Pages'},
//     {t:'Blog',d:'Playbooks, frameworks & field notes',u:'/blogs/insights',c:'Blog'},
//     {t:'Shopify agentic commerce playbook',d:'How to rank in ChatGPT, Gemini & Copilot',u:'/blogs/insights/the-complete-shopify-agentic-commerce-playbook-for-2026',c:'Blog'},
//     {t:'Shopify vs Shopify Plus 2026',d:'Decision framework for upgrading',u:'/blogs/insights/shopify-vs-shopify-plus-in-2026-which-one-is-right-for-your-brand',c:'Blog'},
//     {t:'12-point Shopify speed checklist',d:'Hit sub-2.5s LCP in 10-15 days',u:'/blogs/insights/the-12-point-shopify-speed-checklist-that-gets-you-under-2-5s-lcp',c:'Blog'},
//     {t:'Clinikally case study',d:'380% organic revenue lift',u:'/pages/casestudies/centric-designs-reshaping',c:'Case'},
//     {t:'goom case study',d:'Israeli DTC haircare brand build',u:'/pages/casestudies/works-of-art-in-our-portfolio',c:'Case'},
//     {t:"Dana's Bakery case study",d:'Custom subscription Shopify build',u:'/pages/casestudies/unveiling-iconic-identities',c:'Case'},
//     {t:'Fair Harbor case study',d:'Headless Shopify replatform',u:'/pages/casestudies/fair-harbor-clothing',c:'Case'},
//     {t:'Loops Beauty case study',d:'Mobile-first Shopify Plus revamp',u:'/pages/casestudies/loops-beauty',c:'Case'}
//   ];

//   var searchIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>';

// var DEBOUNCE_MS = 220;
// var debounceTimer = null;
// var requestToken = 0; // guards against out-of-order fetch responses

//   function open(){
//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden','false');
//     document.body.classList.add('search-locked');
//     setTimeout(function(){ input.focus(); renderCombined('', null); },220);
//   }
//   function close(){
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden','true');
//     document.body.classList.remove('search-locked');
//     input.value='';
//     clearTimeout(debounceTimer);
//   }

//   function escape(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

//   function matchCuratedPages(q){
//     if(!q) return curatedPages.slice();
//     return curatedPages.filter(function(p){
//       return (p.t+' '+p.d+' '+p.c).toLowerCase().indexOf(q)>=0;
//     });
//   }

//   function fetchPredictiveResults(q, cb){
//  var url = '/search/suggest.json?q=' + encodeURIComponent(q)
//       + '&resources[type]=product,article,page'
//       + '&resources[limit]=10'
//       + '&resources[options][unavailable_products]=last'
//       + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

//     fetch(url, {headers: {'Accept':'application/json'}})
//       .then(function(res){
//         if(!res.ok) throw new Error('predictive search request failed: ' + res.status);
//         return res.json();
//       })
//       .then(function(data){
//         var resources = (data && data.resources && data.resources.results) || {};
//         cb(null, {
//           products: resources.products || [],
//           articles: resources.articles || [],
//           pages: resources.pages || []
//         });
//       })
//       .catch(function(err){ cb(err, null); });
//   }

//   function renderEmpty(q){
//     resultsEl.innerHTML = '<div class="search-empty"><strong>No matches for &ldquo;'+escape(q)+'&rdquo;</strong>Try a different keyword, or check the spelling of a product name.</div>';
//   }

//   function renderLoading(){
//     resultsEl.innerHTML = '<div class="search-loading">Searching&hellip;</div>';
//   }

//   function productRow(p, isActive){
//     var price = p.price ? '<span class="sr-tag">'+escape(p.price)+'</span>' : '';
//     var thumb = p.image
//       ? '<span class="sr-thumb"><img src="'+escape(p.image)+'" alt="" loading="lazy"></span>'
//       : '<span class="sr-icon">'+searchIconSvg+'</span>';
//     return '<a href="'+escape(p.url)+'"'+(isActive?' class="is-active"':'')+'>'
//       + thumb
//       + '<div class="sr-body"><strong>'+escape(p.title)+'</strong><span>'+escape(p.vendor||'')+'</span></div>'
//       + price
//       + '</a>';
//   }
//  function pageRow(p, isActive){
//   return '<a href="'+p.u+'"'+(isActive?' class="is-active"':'')+'>'
//       +   '<span class="sr-icon">'+searchIconSvg+'</span>'
//       +   '<div class="sr-body"><strong>'+escape(p.t)+'</strong><span>'+escape(p.d)+'</span></div>'
//       +   '<span class="sr-tag">'+escape(p.c)+'</span>'
//       + '</a>';
//   }


//   function articleOrShopifyPageRow(item, isActive){
//     return '<a href="'+escape(item.url)+'"'+(isActive?' class="is-active"':'')+'>'
//       +   '<span class="sr-icon">'+searchIconSvg+'</span>'
//       +   '<div class="sr-body"><strong>'+escape(item.title)+'</strong></div>'
//       + '</a>';
//   }

//   // Renders products (live) + curated pages (local) + articles/pages (live)
//   // as separate labeled sections. Pass predictive=null while a fetch is
//   // pending/not yet run (e.g. on initial open with an empty query).
//   function renderCombined(q, predictive){
//     q = (q||'').trim().toLowerCase();
//     var curated = matchCuratedPages(q);
//     var products = predictive ? predictive.products : [];
//     var articles = predictive ? predictive.articles : [];
//     var shopifyPages = predictive ? predictive.pages : [];

//     var totalCount = curated.length + products.length + articles.length + shopifyPages.length;
//     if(q && totalCount === 0){
//       renderEmpty(q);
//       return;
//     }

//     var html = '';
//     var firstRendered = false;

//     if(products.length){
//       html += '<div class="sr-section"><div class="sr-label">Products ('+products.length+')</div>';
//       products.forEach(function(p){
//         html += productRow(p, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     if(shopifyPages.length || articles.length){
//       var combined = shopifyPages.concat(articles);
//       html += '<div class="sr-section"><div class="sr-label">Pages &amp; Articles ('+combined.length+')</div>';
//       combined.forEach(function(item){
//         html += articleOrShopifyPageRow(item, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     if(curated.length){
//       var label = q ? curated.length+' site result'+(curated.length===1?'':'s') : 'Browse the site';
//       html += '<div class="sr-section"><div class="sr-label">'+label+'</div>';
//       curated.slice(0,12).forEach(function(p){
//         html += pageRow(p, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     resultsEl.innerHTML = html;
//   }

//   function runSearch(rawQuery){
//     var q = rawQuery.trim();

//     // Always render curated matches immediately so the overlay never feels
//     // empty while the network call is in flight.
//     renderCombined(q, null);

//     if(q.length < 2){
//       return; // don't hit the API for 0-1 char queries
//     }

//     renderLoading();
//     var token = ++requestToken;

//     fetchPredictiveResults(q, function(err, predictive){
//       if(token !== requestToken) return; // a newer keystroke superseded this
//       if(err){
//         // Network/API failure — fall back to curated-only results rather
//         // than leaving the user on a permanent "Searching…" state.
//         renderCombined(q, null);
//         return;
//       }
//       renderCombined(q, predictive);
//     });
//   }

//   document.addEventListener('click',function(e){
//     var opener = e.target.closest('[data-search-open]');
//     if(opener){ e.preventDefault(); open(); return; }
//     if(e.target === overlay){ close(); }
//   });
//   document.addEventListener('keydown',function(e){
//     if(e.key==='Escape' && overlay.classList.contains('is-open')) close();
//     if((e.metaKey||e.ctrlKey) && (e.key==='k'||e.key==='K')){ e.preventDefault(); overlay.classList.contains('is-open') ? close() : open(); }
//     if(e.key==='/' && document.activeElement!==input && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)){ e.preventDefault(); open(); }
//   });

//   input.addEventListener('input',function(){
//     var val = input.value;
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(function(){ runSearch(val); }, DEBOUNCE_MS);
//   });

//   input.addEventListener('keydown',function(e){
//     var items = resultsEl.querySelectorAll('a');
//     var idx = -1;
//     items.forEach(function(a,i){ if(a.classList.contains('is-active')) idx=i; });
//     if(e.key==='ArrowDown'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.min(items.length-1, idx+1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
//     if(e.key==='ArrowUp'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.max(0, idx-1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
//     if(e.key==='Enter'){ var active = resultsEl.querySelector('a.is-active'); if(active){ e.preventDefault(); window.location.href = active.getAttribute('href'); } }
//   });
// })();



(function(){
  var overlay = document.getElementById('searchOverlay');
  var input = document.getElementById('siteSearchInput');
  var resultsEl = document.getElementById('searchResults');
  if(!overlay || !input || !resultsEl) return;
 
  // ---- i18n bridge: translations are injected by search-overlay.liquid ----
  var I18N = null;
  function i18n(){
    if(I18N) return I18N;
    var el = document.getElementById('tlxSearchI18n');
    try { I18N = JSON.parse(el.textContent); } catch(e){ I18N = {}; }
    return I18N;
  }
  function L(key){ return (i18n().labels || {})[key] || ''; }
  function withBase(u){ return (i18n().base || '') + u; }
 
  // Only ids, URLs and category keys live here. Text comes from the locale files.
  // Keep in sync with the site map.
  var curatedDefs = [
    {id:'shopify_dev', u:'/pages/shopify-development', c:'shopify'},
    {id:'plus_dev', u:'/pages/shopify-plus-development', c:'shopify'},
    {id:'setup_launch', u:'/pages/shopify-setup-launch', c:'shopify'},
    {id:'app_dev', u:'/pages/shopify-app-development', c:'shopify'},
    {id:'cro', u:'/pages/shopify-cro-audit', c:'growth'},
    {id:'speed', u:'/pages/shopify-speed-optimization-1', c:'growth'},
    {id:'agentic', u:'/pages/shopify-agentic-commerce-1', c:'growth'},
    {id:'mobile_shopify', u:'/pages/mobile-app-development', c:'growth'},
    {id:'support', u:'/pages/support-and-maintenance', c:'shopify'},
    {id:'web_dev', u:'/pages/web-development', c:'software'},
    {id:'mobile_dev', u:'/pages/mobile-app-development', c:'software'},
    {id:'ai', u:'/pages/ai-automation-solutions', c:'ai'},
    {id:'custom_software', u:'/pages/custom-software-development', c:'software'},
    {id:'marketing', u:'/pages/digital-marketing-1', c:'marketing'},
    {id:'uiux', u:'/pages/ui-ux-design-1', c:'design'},
    {id:'all_services', u:'/pages/services', c:'pages'},
    {id:'portfolio', u:'/pages/portfolio', c:'pages'},
    {id:'case_studies', u:'/pages/case-studies', c:'pages'},
    {id:'about', u:'/pages/about-us', c:'pages'},
    {id:'contact', u:'/pages/contact-us', c:'pages'},
    {id:'blog', u:'/blogs/insights', c:'blog'},
    {id:'blog_agentic', u:'/blogs/insights/the-complete-shopify-agentic-commerce-playbook-for-2026', c:'blog'},
    {id:'blog_plus', u:'/blogs/insights/shopify-vs-shopify-plus-in-2026-which-one-is-right-for-your-brand', c:'blog'},
    {id:'blog_speed', u:'/blogs/insights/the-12-point-shopify-speed-checklist-that-gets-you-under-2-5s-lcp', c:'blog'},
    {id:'case_clinikally', u:'/pages/casestudies/centric-designs-reshaping', c:'case'},
    {id:'case_goom', u:'/pages/casestudies/works-of-art-in-our-portfolio', c:'case'},
    {id:'case_danas', u:'/pages/casestudies/unveiling-iconic-identities', c:'case'},
    {id:'case_fairharbor', u:'/pages/casestudies/fair-harbor-clothing', c:'case'},
    {id:'case_loops', u:'/pages/casestudies/loops-beauty', c:'case'}
  ];
 
  var curatedCache = null;
  function getCurated(){
    if(curatedCache) return curatedCache;
    var items = i18n().items || {}, cats = i18n().cats || {};
    curatedCache = curatedDefs.map(function(p){
      return {
        t: items[p.id+'_t'] || p.id,
        d: items[p.id+'_d'] || '',
        u: withBase(p.u),
        c: cats[p.c] || p.c
      };
    });
    return curatedCache;
  }
 
  var searchIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>';
 
  var DEBOUNCE_MS = 220;
  var debounceTimer = null;
  var requestToken = 0; // guards against out-of-order fetch responses
 
  function open(){
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.classList.add('search-locked');
    setTimeout(function(){ input.focus(); renderCombined('', null); },220);
  }
  function close(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.classList.remove('search-locked');
    input.value='';
    clearTimeout(debounceTimer);
  }
 
  function escape(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
 
  function matchCuratedPages(q){
    var all = getCurated();
    if(!q) return all.slice();
    return all.filter(function(p){
      return (p.t+' '+p.d+' '+p.c).toLowerCase().indexOf(q)>=0;
    });
  }
 
  function fetchPredictiveResults(q, cb){
    var url = (i18n().suggest_url || '/search/suggest.json') + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,article,page'
      + '&resources[limit]=10'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
 
    fetch(url, {headers: {'Accept':'application/json'}})
      .then(function(res){
        if(!res.ok) throw new Error('predictive search request failed: ' + res.status);
        return res.json();
      })
      .then(function(data){
        var resources = (data && data.resources && data.resources.results) || {};
        cb(null, {
          products: resources.products || [],
          articles: resources.articles || [],
          pages: resources.pages || []
        });
      })
      .catch(function(err){ cb(err, null); });
  }
 
  function renderEmpty(q){
    resultsEl.innerHTML = '<div class="search-empty"><strong>'+escape(L('no_matches'))+' &ldquo;'+escape(q)+'&rdquo;</strong>'+escape(L('no_matches_hint'))+'</div>';
  }
 
  function renderLoading(){
    resultsEl.innerHTML = '<div class="search-loading">'+escape(L('searching'))+'</div>';
  }
 
  function productRow(p, isActive){
    var price = p.price ? '<span class="sr-tag">'+escape(p.price)+'</span>' : '';
    var thumb = p.image
      ? '<span class="sr-thumb"><img src="'+escape(p.image)+'" alt="" loading="lazy"></span>'
      : '<span class="sr-icon">'+searchIconSvg+'</span>';
    return '<a href="'+escape(p.url)+'"'+(isActive?' class="is-active"':'')+'>'
      + thumb
      + '<div class="sr-body"><strong>'+escape(p.title)+'</strong><span>'+escape(p.vendor||'')+'</span></div>'
      + price
      + '</a>';
  }
 
  function pageRow(p, isActive){
    return '<a href="'+escape(p.u)+'"'+(isActive?' class="is-active"':'')+'>'
      +   '<span class="sr-icon">'+searchIconSvg+'</span>'
      +   '<div class="sr-body"><strong>'+escape(p.t)+'</strong><span>'+escape(p.d)+'</span></div>'
      +   '<span class="sr-tag">'+escape(p.c)+'</span>'
      + '</a>';
  }
 
  function articleOrShopifyPageRow(item, isActive){
    return '<a href="'+escape(item.url)+'"'+(isActive?' class="is-active"':'')+'>'
      +   '<span class="sr-icon">'+searchIconSvg+'</span>'
      +   '<div class="sr-body"><strong>'+escape(item.title)+'</strong></div>'
      + '</a>';
  }
 
  // Renders products (live) + curated pages (local) + articles/pages (live)
  // as separate labeled sections. Pass predictive=null while a fetch is
  // pending/not yet run (e.g. on initial open with an empty query).
  function renderCombined(q, predictive){
    q = (q||'').trim().toLowerCase();
    var curated = matchCuratedPages(q);
    var products = predictive ? predictive.products : [];
    var articles = predictive ? predictive.articles : [];
    var shopifyPages = predictive ? predictive.pages : [];
 
    var totalCount = curated.length + products.length + articles.length + shopifyPages.length;
    if(q && totalCount === 0){
      renderEmpty(q);
      return;
    }
 
    var html = '';
    var firstRendered = false;
 
    if(products.length){
      html += '<div class="sr-section"><div class="sr-label">'+escape(L('products'))+' ('+products.length+')</div>';
      products.forEach(function(p){
        html += productRow(p, !firstRendered);
        firstRendered = true;
      });
      html += '</div>';
    }
 
    if(shopifyPages.length || articles.length){
      var combined = shopifyPages.concat(articles);
      html += '<div class="sr-section"><div class="sr-label">'+escape(L('pages_articles'))+' ('+combined.length+')</div>';
      combined.forEach(function(item){
        html += articleOrShopifyPageRow(item, !firstRendered);
        firstRendered = true;
      });
      html += '</div>';
    }
 
    if(curated.length){
      var label = q ? L('site_results').replace('{n}', curated.length) : L('browse_site');
      html += '<div class="sr-section"><div class="sr-label">'+escape(label)+'</div>';
      curated.slice(0,12).forEach(function(p){
        html += pageRow(p, !firstRendered);
        firstRendered = true;
      });
      html += '</div>';
    }
 
    resultsEl.innerHTML = html;
  }
 
  function runSearch(rawQuery){
    var q = rawQuery.trim();
 
    // Always render curated matches immediately so the overlay never feels
    // empty while the network call is in flight.
    renderCombined(q, null);
 
    if(q.length < 2){
      return; // don't hit the API for 0-1 char queries
    }
 
    renderLoading();
    var token = ++requestToken;
 
    fetchPredictiveResults(q, function(err, predictive){
      if(token !== requestToken) return; // a newer keystroke superseded this
      if(err){
        // Network/API failure — fall back to curated-only results rather
        // than leaving the user on a permanent "Searching…" state.
        renderCombined(q, null);
        return;
      }
      renderCombined(q, predictive);
    });
  }
 
  document.addEventListener('click',function(e){
    var opener = e.target.closest('[data-search-open]');
    if(opener){ e.preventDefault(); open(); return; }
    if(e.target === overlay){ close(); }
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && overlay.classList.contains('is-open')) close();
    if((e.metaKey||e.ctrlKey) && (e.key==='k'||e.key==='K')){ e.preventDefault(); overlay.classList.contains('is-open') ? close() : open(); }
    if(e.key==='/' && document.activeElement!==input && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)){ e.preventDefault(); open(); }
  });
 
  input.addEventListener('input',function(){
    var val = input.value;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function(){ runSearch(val); }, DEBOUNCE_MS);
  });
 
  input.addEventListener('keydown',function(e){
    var items = resultsEl.querySelectorAll('a');
    var idx = -1;
    items.forEach(function(a,i){ if(a.classList.contains('is-active')) idx=i; });
    if(e.key==='ArrowDown'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.min(items.length-1, idx+1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
    if(e.key==='ArrowUp'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.max(0, idx-1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
    if(e.key==='Enter'){ var active = resultsEl.querySelector('a.is-active'); if(active){ e.preventDefault(); window.location.href = active.getAttribute('href'); } }
  });
})();

/* search.js — site overlay search
   Now backed by Shopify's Predictive Search API for products/articles/pages,
   merged with a small curated list of marketing pages that aren't real
   Shopify page/article objects (service pages, case studies, etc).
*/
// (function(){
//   var overlay = document.getElementById('searchOverlay');
//   var input = document.getElementById('siteSearchInput');
//   var resultsEl = document.getElementById('searchResults');
//   if(!overlay || !input || !resultsEl) return;

//   /* i18n - OLD: 29 curated entries were hardcoded in English right here, as
//      an array of {t, d, u, c} objects. A .js asset cannot call Liquid's `| t`
//      filter, so nothing could ever translate them - they stayed English on the
//      Arabic and Hebrew sites, which is exactly what visitors were reporting.

//      They now come from the JSON block that sections/search-overlay.liquid
//      renders, where each field goes through `| t`. The shape is unchanged
//      ({t, d, u, c}), so every function below works as before.

//      Read once at startup. If the block is missing - section disabled, or an
//      older cached copy of the section - this falls back to an empty list rather
//      than throwing, so search still opens and live results still work. */
//   var SEARCH_DATA = (function(){
//     var fallback = { ui: {}, curated: [] };
//     var el = document.getElementById('searchData');
//     if(!el) return fallback;
//     try {
//       var parsed = JSON.parse(el.textContent);
//       return {
//         ui: parsed.ui || {},
//         curated: parsed.curated || []
//       };
//     } catch(e){
//       if(window.console) console.warn('[search] could not parse #searchData', e);
//       return fallback;
//     }
//   })();

//   var curatedPages = SEARCH_DATA.curated;

//   /* Looks up a UI string, falling back to the English wording that used to be
//      hardcoded below, so a missing locale key degrades to readable text instead
//      of an empty element. */
//   function uiText(key, fallback){
//     var v = SEARCH_DATA.ui[key];
//     return (typeof v === 'string' && v.length) ? v : fallback;
//   }

//   var searchIconSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>';

//   var DEBOUNCE_MS = 220;
//   var debounceTimer = null;
//   var requestToken = 0; // guards against out-of-order fetch responses

//   /* locale fix - NEW: route every URL through the store's current language.
//      Shopify.routes.root is "/" on English, "/ar/" on Arabic, "/he/" on Hebrew.
//      URLs here were hardcoded, so Arabic pages still requested the English
//      locale and got English suggestions back. */
//   var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

//   function localized(path) {
//     return ROOT.replace(/\/$/, '') + path;
//   }

//   function open(){
//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden','false');
//     document.body.classList.add('search-locked');
//     setTimeout(function(){ input.focus(); renderCombined('', null); },220);
//   }
//   function close(){
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden','true');
//     document.body.classList.remove('search-locked');
//     input.value='';
//     clearTimeout(debounceTimer);
//   }

//   function escape(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}

//   function matchCuratedPages(q){
//     if(!q) return curatedPages.slice();
//     return curatedPages.filter(function(p){
//       return (p.t+' '+p.d+' '+p.c).toLowerCase().indexOf(q)>=0;
//     });
//   }

//   function fetchPredictiveResults(q, cb){
//     /* locale fix - OLD: var url = '/search/suggest.json?q=' + encodeURIComponent(q) */
//     var url = localized('/search/suggest.json') + '?q=' + encodeURIComponent(q)
//       + '&resources[type]=product,article,page'
//       + '&resources[limit]=10'
//       + '&resources[options][unavailable_products]=last'
//       + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

//     fetch(url, {headers: {'Accept':'application/json'}})
//       .then(function(res){
//         if(!res.ok) throw new Error('predictive search request failed: ' + res.status);
//         return res.json();
//       })
//       .then(function(data){
//         var resources = (data && data.resources && data.resources.results) || {};
//         cb(null, {
//           products: resources.products || [],
//           articles: resources.articles || [],
//           pages: resources.pages || []
//         });
//       })
//       .catch(function(err){ cb(err, null); });
//   }

//   function renderEmpty(q){
//     /* i18n - OLD: the English sentence was written straight into the markup:
//        '<strong>No matches for &ldquo;'+escape(q)+'&rdquo;</strong>Try a different
//         keyword, or check the spelling of a product name.'
//        The {q} token is substituted after escaping, so the visitor's own typed
//        text can never inject markup. */
//     var title = uiText('no_match_title', 'No matches for “{q}”').replace('{q}', escape(q));
//     var body  = uiText('no_match_body', 'Try a different keyword, or check the spelling of a product name.');
//     resultsEl.innerHTML = '<div class="search-empty"><strong>'+title+'</strong>'+body+'</div>';
//   }

//   function renderLoading(){
//     /* i18n - OLD: '<div class="search-loading">Searching&hellip;</div>' */
//     resultsEl.innerHTML = '<div class="search-loading">'+uiText('searching', 'Searching…')+'</div>';
//   }

//   function productRow(p, isActive){
//     var price = p.price ? '<span class="sr-tag">'+escape(p.price)+'</span>' : '';
//     var thumb = p.image
//       ? '<span class="sr-thumb"><img src="'+escape(p.image)+'" alt="" loading="lazy"></span>'
//       : '<span class="sr-icon">'+searchIconSvg+'</span>';
//     return '<a href="'+escape(p.url)+'"'+(isActive?' class="is-active"':'')+'>'
//       + thumb
//       + '<div class="sr-body"><strong>'+escape(p.title)+'</strong><span>'+escape(p.vendor||'')+'</span></div>'
//       + price
//       + '</a>';
//   }

//   function pageRow(p, isActive){
//     /* locale fix - OLD: '<a href="'+p.u+'"' ... — curated URLs had no locale
//        prefix, so a click from /ar/ landed the visitor back on the English site. */
//     return '<a href="'+localized(p.u)+'"'+(isActive?' class="is-active"':'')+'>'
//       +   '<span class="sr-icon">'+searchIconSvg+'</span>'
//       +   '<div class="sr-body"><strong>'+escape(p.t)+'</strong><span>'+escape(p.d)+'</span></div>'
//       +   '<span class="sr-tag">'+escape(p.c)+'</span>'
//       + '</a>';
//   }

//   function articleOrShopifyPageRow(item, isActive){
//     return '<a href="'+escape(item.url)+'"'+(isActive?' class="is-active"':'')+'>'
//       +   '<span class="sr-icon">'+searchIconSvg+'</span>'
//       +   '<div class="sr-body"><strong>'+escape(item.title)+'</strong></div>'
//       + '</a>';
//   }

//   // Renders products (live) + curated pages (local) + articles/pages (live)
//   // as separate labeled sections. Pass predictive=null while a fetch is
//   // pending/not yet run (e.g. on initial open with an empty query).
//   function renderCombined(q, predictive){
//     q = (q||'').trim().toLowerCase();
//     var curated = matchCuratedPages(q);
//     var products = predictive ? predictive.products : [];
//     var articles = predictive ? predictive.articles : [];
//     var shopifyPages = predictive ? predictive.pages : [];

//     var totalCount = curated.length + products.length + articles.length + shopifyPages.length;
//     if(q && totalCount === 0){
//       renderEmpty(q);
//       return;
//     }

//     var html = '';
//     var firstRendered = false;

//     if(products.length){
//       /* i18n - OLD: '<div class="sr-label">Products ('+products.length+')</div>' */
//       html += '<div class="sr-section"><div class="sr-label">'
//         + uiText('label_products', 'Products ({count})').replace('{count}', products.length)
//         + '</div>';
//       products.forEach(function(p){
//         html += productRow(p, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     if(shopifyPages.length || articles.length){
//       var combined = shopifyPages.concat(articles);
//       /* i18n - OLD: '<div class="sr-label">Pages &amp; Articles ('+combined.length+')</div>' */
//       html += '<div class="sr-section"><div class="sr-label">'
//         + escape(uiText('label_pages', 'Pages & Articles ({count})').replace('{count}', combined.length))
//         + '</div>';
//       combined.forEach(function(item){
//         html += articleOrShopifyPageRow(item, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     if(curated.length){
//       /* i18n - OLD: q ? curated.length+' site result'+(curated.length===1?'':'s') : 'Browse the site'
//          English pluralised by appending "s". Other languages do not, so the
//          one/other forms are now two separate locale keys. */
//       var label = q
//         ? escape(uiText(curated.length === 1 ? 'label_results_one' : 'label_results_other',
//             curated.length === 1 ? '{count} site result' : '{count} site results'
//           ).replace('{count}', curated.length))
//         : escape(uiText('label_browse', 'Browse the site'));
//       html += '<div class="sr-section"><div class="sr-label">'+label+'</div>';
//       curated.slice(0,12).forEach(function(p){
//         html += pageRow(p, !firstRendered);
//         firstRendered = true;
//       });
//       html += '</div>';
//     }

//     resultsEl.innerHTML = html;
//   }

//   function runSearch(rawQuery){
//     var q = rawQuery.trim();

//     // Always render curated matches immediately so the overlay never feels
//     // empty while the network call is in flight.
//     renderCombined(q, null);

//     if(q.length < 2){
//       return; // don't hit the API for 0-1 char queries
//     }

//     renderLoading();
//     var token = ++requestToken;

//     fetchPredictiveResults(q, function(err, predictive){
//       if(token !== requestToken) return; // a newer keystroke superseded this
//       if(err){
//         // Network/API failure — fall back to curated-only results rather
//         // than leaving the user on a permanent "Searching…" state.
//         renderCombined(q, null);
//         return;
//       }
//       renderCombined(q, predictive);
//     });
//   }

//   document.addEventListener('click',function(e){
//     var opener = e.target.closest('[data-search-open]');
//     if(opener){ e.preventDefault(); open(); return; }
//     if(e.target === overlay){ close(); }
//   });
//   document.addEventListener('keydown',function(e){
//     if(e.key==='Escape' && overlay.classList.contains('is-open')) close();
//     if((e.metaKey||e.ctrlKey) && (e.key==='k'||e.key==='K')){ e.preventDefault(); overlay.classList.contains('is-open') ? close() : open(); }
//     if(e.key==='/' && document.activeElement!==input && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)){ e.preventDefault(); open(); }
//   });

//   input.addEventListener('input',function(){
//     var val = input.value;
//     clearTimeout(debounceTimer);
//     debounceTimer = setTimeout(function(){ runSearch(val); }, DEBOUNCE_MS);
//   });

//   input.addEventListener('keydown',function(e){
//     var items = resultsEl.querySelectorAll('a');
//     var idx = -1;
//     items.forEach(function(a,i){ if(a.classList.contains('is-active')) idx=i; });
//     if(e.key==='ArrowDown'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.min(items.length-1, idx+1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
//     if(e.key==='ArrowUp'){ e.preventDefault(); if(items.length){ if(idx>=0) items[idx].classList.remove('is-active'); var n=Math.max(0, idx-1); items[n].classList.add('is-active'); items[n].scrollIntoView({block:'nearest'}); } }
//     if(e.key==='Enter'){ var active = resultsEl.querySelector('a.is-active'); if(active){ e.preventDefault(); window.location.href = active.getAttribute('href'); } }
//   });
// })();